export default __webpack_public_path__ + "static/media/investment.ee8e6601.svg";